<template>
  <aside
    v-if="!mq.isMobile"
    class="p-4 flex flex-col gap-4 items-center rounded-r-2xl bg-white"
    style="box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1)"
  >
    <div class="flex-center max-h-[100px] w-[30px] mb-5">
      <img
        class="h-20 object-contain"
        :src="ZigguLogo"
        alt="A green z character with eyes and a smile waving at you. Has a white background. Gloves like mickey mouse. Boots like a cartoon character."
      />
    </div>
    <div class="flex flex-col gap-2 justify-between h-full w-full">
      <div class="flex flex-col gap-2 w-full">
        <NavbarItem
          v-for="(item, idx) in NAVBAR_ITEMS_SUPERVISORS"
          :key="idx"
          :hide_title="true"
          :item="item"
        />
      </div>
    </div>
    <ProfileDropdown
      #reference
      :show_name="false"
    />
  </aside>
  <div
    v-else
    class="m-2"
  >
    <div
      class="flex justify-center items-center size-12 rounded-full cursor-pointer bg-white"
      @click="toggleSidebar"
    >
      <FontAwesomeIcon
        class="text-2xl"
        :icon="['far', 'bars']"
      />
    </div>
    <Popover
      ref="popover"
      class="flex flex-col gap-3 p-3"
    >
      <NavbarItem
        v-for="(item, idx) in NAVBAR_ITEMS_SUPERVISORS"
        :key="idx"
        :hide_title="false"
        :item="item"
        @click="toggleSidebar(false)"
      />
      <ProfileDropdown #reference />
    </Popover>
  </div>
</template>

<script setup>
import NavbarItem from '@/app/shared_components/navbar/NavbarItem.vue';
import { NAVBAR_ITEMS_SUPERVISORS } from '@/app/data/navbar_constants';
import ZigguLogo from '@/assets/images/upsell/ziggy.jpg';
import ProfileDropdown from '@/app/shared_components/navbar/TheProfileDropdown.vue';
import { ref } from 'vue';

const popover = ref(null);

const toggleSidebar = (event) => {
  popover.value.toggle(event);
};
</script>
